'use client'

import { IconEyeOnFill, IconHeartFill } from '@macarongfactory/web-icons'

import { formatNumber } from '@/shared/lib'

import { type IMycleContentStat } from '../model'

interface IContentStatsProps {
  stat: IMycleContentStat
}

/** 조회수/좋아요 카운트 표시 (콘텐츠 카드 하단) */
const ContentStats = ({ stat }: IContentStatsProps) => {
  return (
    <div className='gap-x-dimension-x1-5 flex items-center'>
      <StatItem
        icon={
          <IconEyeOnFill
            width={14}
            height={24}
            className='text-foreground-neutral-muted'
          />
        }
        value={stat.viewCount}
      />
      <StatItem
        icon={
          <IconHeartFill
            width={14}
            height={24}
            className='text-foreground-neutral-muted'
          />
        }
        value={stat.likeCount}
      />
    </div>
  )
}

const StatItem = ({
  icon,
  value,
}: {
  icon: React.ReactNode
  value: number
}) => {
  return (
    <div className='gap-x-dimension-x0-5 flex items-center'>
      {icon}
      <p className='text-caption-1-medium text-foreground-neutral-assistive truncate'>
        {formatNumber(value)}
      </p>
    </div>
  )
}

export default ContentStats
